import React from 'react';
import { FormattedRelative } from 'react-intl';

import { Pill } from '@99designs/common/components/Pill';
import { FormattedMessage } from '@99designs/common/i18n';
import { BriefDetails_StructuredBrief as BriefFragment } from '__generated__/BriefDetails_StructuredBrief';
import { Color } from 'projects/consts';
import AvatarCollection from './AvatarCollection';
import ColorComponent from './Color';
import User from './User';

interface Props {
    drafts: BriefFragment[];
    heading: string;
    onClick: (brief: BriefFragment) => void;
}

const BriefDetailsList = ({ drafts, onClick, heading }: Props) => (
    <div className="brief-details-list">
        <div className="brief-details-list__header">
            <ColorComponent color={Color.createBlue}>
                <div className="heading heading--h4">{heading}</div>
            </ColorComponent>
        </div>
        {drafts.map((draft, id) => (
            <React.Fragment key={id}>
                {id > 0 && <div className="brief-details-list__hr" />}
                <div className="brief-details-list__item" onClick={() => onClick(draft)}>
                    <div className="brief-details-list__inner">
                        <BriefDetails {...draft} />
                    </div>
                </div>
            </React.Fragment>
        ))}
    </div>
);

interface BriefDetailsProps extends BriefFragment {}

const BriefDetails = ({ title, category, designers, createdAt }: BriefDetailsProps) => (
    <div className="brief-details">
        <div className="brief-details__title" title={title}>
            {title}
        </div>
        <div className="brief-details__break brief-details__break--small" />
        {category && (
            <div className="brief-details__category">
                <Pill>{category.title}</Pill>
            </div>
        )}
        {designers.length === 1 && (
            <>
                <div className="brief-details__break" />
                <div className="brief-details__designers">
                    <User user={designers[0]} size={'extra-small'} />
                </div>
            </>
        )}
        {designers.length > 1 && (
            <>
                <div className="brief-details__break" />
                <div className="brief-details__designers">
                    <AvatarCollection users={designers} size={'extra-small'} limit={5} />
                </div>
            </>
        )}
        <div className="brief-details__created">
            <div className="paragraph paragraph--soft paragraph--no-margin paragraph--small">
                <FormattedMessage
                    message={__('Created {time}')}
                    values={{ time: <FormattedRelative value={createdAt} /> }}
                />
            </div>
        </div>
    </div>
);

export default BriefDetailsList;
